import { toast } from 'react-hot-toast';
import { ICreateInventoryData } from '../@types';
import { Inventory, InventoryInput, RestockInput, editInventory } from '../@types/inventory';
import { inventoryService } from '../services';
const BASE = `inventories`;

export const deleteInventory = async (id: string) => {
  try {
    const res = await inventoryService.delete(`/${BASE}/${id}`);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};



export const deleteVariation = async (id: string) => {
  try {
    const res = await inventoryService.patch(`/${BASE}/variation/${id}`);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};
export const updateInventory = async (id: string, data: editInventory) => {
  try {
    const res = await inventoryService.patch(`/${BASE}/${id}`, data);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};
export const restockInventory = async (id: string, data: RestockInput) => {
  try {
    const res = await inventoryService.patch(`/${BASE}/restock/${id}`, data);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const createInventory = async (data: InventoryInput) => {
  try {
    const res = await inventoryService.post(`/${BASE}`, data);
    console.log(res);
    return res.data;
  } catch (e: any) {
    console.log(e);
    throw new Error(e.response?.data || e.message);
  }
};

export const getInventory = async (id: string) => {
  try {
    const res = await inventoryService.get(`/${BASE}/${id}`);
    return res.data;
  } catch (e: any) {
    toast.error(e.response?.data || e.message);
    throw new Error(e.response?.data || e.message);
  }
};

export const createVariationService = async (data:{variantName: string, types: string[]}) => {
  try {
    const res = await inventoryService.post(`/${BASE}/variant`, data)
    return res?.data
  } catch (err:any) {
    toast.error(err.message)
    throw new Error(err.response?.data || err.message)
  }
}

export const editVariationService = async (id:number, data:{variantName:string, types: string[]}) => {
  try {
    const res = await inventoryService.patch(`/inventories/variant/${id}`, data)
    return res.data
  } catch (error:any) {
    throw new Error(error?.message || error.response?.data)
  }
}

export const deleteVariationService = async (id:number) => {
   try {
    const res = await inventoryService.delete(`/${BASE}/variant/${id}`)
    return res.data 
   } catch (e: any) {
    toast.error(e.message || e.response?.data) 
    throw new Error(e.message || e.response?.data)
   }
}